import { render, staticRenderFns } from "./BookingStep.vue?vue&type=template&id=5a1ce842&scoped=true&"
import script from "./BookingStep.vue?vue&type=script&lang=js&"
export * from "./BookingStep.vue?vue&type=script&lang=js&"
import style0 from "./BookingStep.vue?vue&type=style&index=0&id=5a1ce842&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1ce842",
  null
  
)

export default component.exports